export default __webpack_public_path__ + "static/media/nuskin.dd00912f.svg";